export default __webpack_public_path__ + "static/media/dreamscape_account_students.348c0251.png";